var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCaretRight = function SvgCaretRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 9 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.175 6.9a1.125 1.125 0 0 0 0-1.8l-6-4.5a1.125 1.125 0 0 0-1.8.9v9a1.125 1.125 0 0 0 1.8.9l6-4.5Z",
    fill: "currentColor"
  })));
};

export { SvgCaretRight as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOSIgaGVpZ2h0PSIxMiIgdmlld0JveD0iMCAwIDkgMTIiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik04LjE3NSA2LjkwMDAxQzguNDU4MjggNi42ODc1NSA4LjYyNSA2LjM1NDExIDguNjI1IDYuMDAwMDFDOC42MjUgNS42NDU5MSA4LjQ1ODI4IDUuMzEyNDcgOC4xNzUgNS4xMDAwMUwyLjE3NSAwLjYwMDAwNkMxLjgzNDEgMC4zNDQzMzUgMS4zNzgwMiAwLjMwMzIxIDAuOTk2ODg1IDAuNDkzNzc2QzAuNjE1NzUzIDAuNjg0MzQyIDAuMzc1IDEuMDczODkgMC4zNzUgMS41MDAwMVYxMC41QzAuMzc1IDEwLjkyNjEgMC42MTU3NTMgMTEuMzE1NyAwLjk5Njg4NSAxMS41MDYyQzEuMzc4MDIgMTEuNjk2OCAxLjgzNDEgMTEuNjU1NyAyLjE3NSAxMS40TDguMTc1IDYuOTAwMDFaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K";